import { Box, ContentTemplate, Progress, TextFieldForm } from 'web-library';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { fallbackDashString } from 'web-library/utils/StringUtils';
import { AdminProfileResponseObject } from 'web-library/models/AccountManagementConfiguration';
import ToggleDisplayEditFormItem from '../../../components/ToggleDisplayEditFormItem';
import { ContactNumberFormItem } from '../../../components/form-items/ContactNumberFormItem';
import { getIExamMasterCodeSelected } from '../../../modules/profile/logic/useCandidateProfileForm';
import { useStyles } from './index';
import { useGetIExamMasterCode } from '../../../api-refactored/user/useGetIExamMasterCode';
import { IExamMasterCodeItem } from '../../../api/user/model';
import { CreateEditAdminSchemaData } from './CreateEditAdminSchema';

interface AdminContactInformationProps {
  isEditState: boolean;
  formHook?: UseFormReturn<CreateEditAdminSchemaData>;
  adminProfileDetails?: AdminProfileResponseObject;
}

const AdminContactInformation = ({
  isEditState,
  formHook,
  adminProfileDetails,
}: AdminContactInformationProps) => {
  const { t } = useTranslation();

  const { classes } = useStyles();

  const { data: iExamMasterCode } = useGetIExamMasterCode();

  const mobileNumberCountryCodeDefaultObject =
    iExamMasterCode &&
    iExamMasterCode.countryCode.find(
      (obj: IExamMasterCodeItem) =>
        obj.codeValue === adminProfileDetails?.mobileNumberCountryCode?.toString()
    );

  if (
    adminProfileDetails?.mobileNumberCountryCode &&
    mobileNumberCountryCodeDefaultObject === undefined
  ) {
    return (
      <ContentTemplate>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <Box className={classes.responsiveFlexContainer}>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        containerClassName={classes.formElementContainer}
        labelText={t('profile->>CreateCandidateForm.Email')}
        id="inputText-candidateProfile-email"
        valueText={adminProfileDetails?.email}
        EditComponent={
          formHook && (
            <TextFieldForm
              id="inputText-adminProfile-email"
              form={formHook}
              label={t('profile->>CreateCandidateForm.Email')}
              placeholder="Enter email"
              defaultValue={adminProfileDetails?.email}
              name="email"
              type="text"
              error={!!formHook.formState.errors.email}
              helperText={formHook.formState.errors?.email?.message?.toString()}
              fullWidth
              isRequired
            />
          )
        }
      />

      <ToggleDisplayEditFormItem
        id="mobileNo"
        isEditState={isEditState}
        labelText={t('profile->>CreateCandidateForm.Mobile No.')}
        valueText={fallbackDashString(
          `${adminProfileDetails?.mobileNumberPrefix || '+'}${
            adminProfileDetails?.mobileNumberCountryCode
          } ${adminProfileDetails?.mobileNumber}`
        )}
        containerClassName={classes.formElementContainer}
        EditComponent={
          formHook && (
            <ContactNumberFormItem
              id="candidateProfileMobile"
              formHook={formHook}
              label={t('profile->>CreateCandidateForm.Mobile No.')}
              placeholder="Enter mobile no."
              countryCode={{
                name: 'mobileCountryCode',
                error: !!formHook.formState.errors.mobileCountryCode,
                helperText: formHook.formState.errors?.mobileCountryCode?.message?.toString(),
              }}
              countryCodeisOptionEqualToValue={getIExamMasterCodeSelected}
              number={{
                name: 'mobileContactNumber',
                error: !!formHook.formState.errors.mobileContactNumber,
                helperText: formHook.formState.errors?.mobileContactNumber?.message?.toString(),
              }}
              countryCodeDefaultValue={mobileNumberCountryCodeDefaultObject}
              numberDefaultValue={adminProfileDetails?.mobileNumber}
              isSkipTransform
              isRequired
            />
          )
        }
      />
    </Box>
  );
};

export default AdminContactInformation;
